module.exports = __webpack_public_path__ + "img/refresh-ccw-05.3d4f5f65.svg";